import { WebApiModelsMemberField } from "../Repository/eventbookyapi";
import { MemberFieldTypes } from "../Types/MemberFieldTypes";

export const getMemberFieldSetting = (
    type: MemberFieldTypes,
    fields: WebApiModelsMemberField[],
    customFieldId: number | string | null | undefined
) => {
    if (type === MemberFieldTypes.Custom && customFieldId != null) {
        // Try to find by id or fieldId (support both string and number)
        return fields.find(
            f => (f.id === customFieldId || (f as any).fieldId === customFieldId)
        ) || {};
    }
    // fallback to columnType
    return fields.find(f => f.columnType == type) || {};
}